module.exports = __webpack_public_path__ + "img/2-20.183e620f.jpg";